import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formattedDate } from '@/utils/date';
import { PlannerRestoreFromBackupList } from '../planner-restore/planner-restore-list';
import BackupListactions from './BackupListActions';
import { Dispatch, SetStateAction } from 'react';

export const columns = (
  setShowDiff: Dispatch<SetStateAction<string>>,
  setRestoreDialogData: Dispatch<SetStateAction<PlannerRestoreFromBackupList>>,
): ColumnDef<PlannerRestoreFromBackupList>[] => [
  {
    accessorKey: 'backupId',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Backup id
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>{row.getValue('backupId')}</div>
      );
    },
  },
  {
    accessorKey: 'identifier',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Identifier
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>
          {row.getValue('identifier')}
        </div>
      );
    },
  },
  {
    accessorKey: 'backupTime',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Last modified
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      const dateString: string = row.getValue('backupTime');

      return (
        <div className='text-left font-medium'>{formattedDate(dateString)}</div>
      );
    },
    meta: { hiddenOnMobile: true },
  },
  {
    accessorKey: 'modifiedBy',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Modified by
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>
          {row.getValue('modifiedBy')}
        </div>
      );
    },
    meta: { hiddenOnMobile: true },
  },
  {
    id: 'edit',
    enableHiding: false,
    cell: ({ row }) => {
      const planner = row.original;

      return (
        <BackupListactions
          data={planner}
          setShowDiff={setShowDiff}
          setRestoreDialogData={setRestoreDialogData}
        />
      );
    },
  },
];
